<script setup>
import BaseIcon from '@/components/shared/ui/BaseIcon.vue'
import BaseIconButton from '@/components/shared/ui/BaseIconButton.vue'
import { useAuthStore } from '@/pinia/auth'
import { useStyleStore } from '@/pinia/style'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const authStore = useAuthStore()
const styleStore = useStyleStore()
const route = useRoute()

function closeForAWeek() {
  authStore.lastClosedMaintenancePopUp = new Date()
}

const isPopUp = computed(() => {
  const lastClosedMaintenancePopUp = new Date(authStore.lastClosedMaintenancePopUp)
  // Internally calls getTime
  if (isNaN(lastClosedMaintenancePopUp)) {
    return true
  }
  const aWeek = 7 * 24 * 60 * 60 * 1000
  const current = new Date().getTime()
  return lastClosedMaintenancePopUp.getTime() + aWeek < current
})
</script>

<template>
  <div
    v-if="!route.name?.includes('Design Online') && isPopUp && styleStore.fabricator?.systemMessage"
    class="fixed top-0 !z-50 w-full p-3 pointer-events-none"
  >
    <div
      class="relative flex gap-5 w-full mx-auto max-w-[1000px] rounded border border-amber-300 bg-amber-100 shadow-xl p-5 pointer-events-auto"
    >
      <div class="flex gap-4 w-full">
        <div class="hidden xs:flex flex-col justify-start pt-2 text-amber-800">
          <BaseIcon icon="warning" class="text-xl" />
        </div>
        <div class="grow">
          <p class="font-medium text-amber-950">{{ $t('common.global.importantNotice') }}</p>
          <p class="text-sm text-amber-900">{{ styleStore.fabricator.systemMessage }}</p>
        </div>
        <BaseIconButton icon="cancel" size="lg" class="text-amber-900 ml-auto self-start" @click="closeForAWeek" />
      </div>
    </div>
  </div>
</template>
